import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import {MainService} from './main.service';
@Injectable({
  providedIn: 'root'
})

export class ChartOfAccountService {
  httpUrl;
  constructor(private http: HttpClient, private main: MainService) { 
    this.httpUrl = this.main.httpUrl+"/accounts/chartofaccount";
  }
  async  getchartofaccount(obj:any){
    const resp = this.http.get<any>(this.httpUrl + '/getchartofaccount' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  createchartofaccount(obj:any){
    const resp = this.http.post<any>(this.httpUrl + '/createchartofaccount' ,obj).toPromise().then(res => {
      console.log(res)
      return res
    });
    return resp
  }
  async  deleteChartOfAccount(obj:any){
    const resp = this.http.delete<any>(this.httpUrl + '/deleteChartOfAccount' +obj).toPromise().then(res => {
      console.log(res)
      return res
    });
    return resp
  }

  async deletechartofaccount(obj:any){
    const resp = this.http.delete<any>(this.httpUrl + '/deletechartofaccount' + JSON.stringify(obj)).toPromise().then(res => {
      return res
    });
    return resp
  }

  async  moveChartOfAccountHierarchy(obj:any){
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/coa/moveHierarchy',obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  updatechartofaccount(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl+'/updatechartofaccount',obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  ////////////******Chart of Account start*********/
  async  createChartOfAccountHierarchy(obj:any){
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/coa/createHierarchy' ,obj).toPromise().then(res => {
      console.log(res)
      return res
    });
    return resp
  }

  async  getChartOfAccountHierarchy(obj:any){
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/hierarchies/coa/getHierarchy',obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  getAllTranstion(obj:any){
    const resp = this.http.get<any>(this.main.httpUrl + '/accounts/hierarchies/coa/getTotalTxnamt'+obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async deleteChartOfAccountHierarchy(obj:any){
    const resp = this.http.put<any>(this.main.httpUrl + '/accounts/hierarchies/coa/deleteHierarchy' ,obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async updateChartOfAccountHierarchy(obj:any){
    const resp = this.http.put<any>(this.main.httpUrl + '/accounts/hierarchies/coa/updateHierarchy' ,obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async  processCoaExcel(obj:any){
    const resp = this.http.post<any>(this.main.httpUrl + '/accounts/chartofaccount/processCoaExcel',obj).toPromise().then(res => {
      return res
    });
    return resp
  }


  ////////////******Chart of Account end*********/

}
